import { showToast } from "./toast";

const SAVE_DELAY_MS = 300;
const timers = new Map<string, number>();
const pending = new Map<string, Record<string, unknown>>();

function put(url: string, changes: Record<string, unknown>, failure: string): void {
  const csrf = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || "";
  pending.set(url, { ...(pending.get(url) || {}), ...changes });

  window.clearTimeout(timers.get(url));
  timers.set(url, window.setTimeout(() => {
    const body = pending.get(url) || {};
    pending.delete(url);
    fetch(url, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": csrf },
      body: JSON.stringify(body),
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
      })
      .catch(() => showToast(failure, "error"));
  }, SAVE_DELAY_MS));
}

export function saveSidebarState(collapsed: boolean): void {
  put("/me/preferences", { sidebar: collapsed ? "collapsed" : "expanded" }, "Couldn't save your sidebar setting");
}

export interface CsListView {
  view?: "table" | "focus" | "campaigns";
  density?: "compact" | "comfortable";
  hidden?: string[];
}

export function saveCsListView(changes: CsListView): void {
  put("/me/views/customer-success", changes as Record<string, unknown>, "Couldn't save your view settings");
}
